module.exports = __webpack_public_path__ + "media/images/img-car-2-6e8c7624.png";